import map from "lodash/fp/map";
import constants from "../../core/constants";

const formatRate = (item) => item * constants.currencyBy;
class BasicplansPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Basic Plan",
      state: "basicplan",
      name: "basicPlan",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Rides per day", name: "rides_per_day", isSortable: true },
      { title: "Rate", name: "rate", isSortable: true },
    ];

    this.filters = [
      {
        name: "basicplan",
        title: "Basic Plan",
        icon: "",
        resource: "BasicPlan",
        isSearch: true,
        state: "basicplan",
      },
    ];

    this.addOptions = {
      title: "Add New Basic plan",
      icon: "add",
      fields: [
        {
          name: "name",
          title: "Basic plan name",
          type: "name",
          isText: true,
          isRequired: true,
        },
        {
          name: "description",
          title: "Basic plan description",
          type: "name",
          isText: true,
          isRequired: true,
        },
        { resource: "City", name: "city", title: "City", isResource: true },
        {
          name: "rides_per_day",
          title: "Rides per day",
          type: "number",
          isText: true,
          isRequired: true,
        },
        {
          name: "rate",
          title: "Rate per one ride",
          type: "number",
          isText: true,
          isRequired: true,
          formatter: formatRate,
        },
      ],
    };
  }

  justify(data) {
    const format = (item) => {
      item.rate /= constants.currencyBy;

      return item;
    };
    return map(format)(data);
  }
}

export default BasicplansPageTransform;



// WEBPACK FOOTER //
// ./src/pages/basicplans/basicplans.transforms.js